const USER_POINTS_CACHE_ID = 'user-points';
const USER_PROMOTIONS_CACHE_ID = 'user-promotions';
const USER_REWARDS_CACHE_ID = 'user-rewards';

export { USER_POINTS_CACHE_ID, USER_PROMOTIONS_CACHE_ID, USER_REWARDS_CACHE_ID };
